/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';

export interface IPreOpInstructions {
  id?: string;
  nilByMouthFrom?: string | null;
  reserveBloodProducts?: string | null;
  preMedications?: string | null;
  specificInstructions?: string | null;
  otherSpecificInstructions?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  anaesthesiologist?: IDoctor;
}

export const defaultValue: Readonly<IPreOpInstructions> = {
  active: false,
};
